import { CSSProperties } from 'react';
import { FlexContainer } from '@facephi/ui-react';
import ReactECharts from 'echarts-for-react';
import Skeleton from 'react-loading-skeleton';
import { DEFAULT_LOCALE, translate } from '../../utils/translations';
import { COLORS } from './model';
import { DonutChartLoading } from './Styles';
import { getValueCustomProperties } from './utils';

export type DataDonutChart = {
  name: string;
  value: number;
};

type IProps = {
  data: DataDonutChart[];
  subtitle?: string;
  style?: CSSProperties;
  loading?: boolean;
  center?: string[];
  radius?: string;
  locale?: string;
};
export const DonutChart = ({
  data = [],
  subtitle,
  style,
  loading,
  center = ['50%', '35%'],
  radius = '70%',
  locale = DEFAULT_LOCALE,
}: IProps) => {
  const options = {
    tooltip: {
      trigger: 'item',
    },
    textStyle: {
      fontFamily: 'Poppins',
      color: getValueCustomProperties('grey700'),
      fontSize: 10,
    },
    legend: {
      orient: 'horizontal',
      align: 'left',
      bottom: '0',
      itemGap: 20,
      textStyle: {
        color: getValueCustomProperties('grey700'),
        fontFamily: 'Poppins',
        fontSize: 10,
      },
      itemStyle: {
        borderType: 'solid',
        borderWidth: 2,
        borderColor: getValueCustomProperties('white'),
      },
    },
    series: [
      {
        type: 'pie',
        radius: radius,
        center: center,
        label: {
          show: false,
        },
        data: data.map((item: DataDonutChart, index) => ({
          ...item,
          name: translate(item.name, locale),
          itemStyle: {
            color: COLORS[index],
          },
        })),
        emphasis: {
          itemStyle: {
            shadowBlur: 0,
            shadowOffsetX: 0,
            shadowColor: 'rgba(0, 0, 0, 0.5)',
          },
        },
      },
    ],
  };
  return (
    <>
      {loading ? (
        <>
          <DonutChartLoading>
            <Skeleton circle height={200} width={200} />
          </DonutChartLoading>
          <FlexContainer
            flexDirection="row"
            columnGap="2.2"
            justifyContent="center"
          >
            <Skeleton height={10} width={50} borderRadius={14} />
            <Skeleton height={10} width={50} borderRadius={14} />
            <Skeleton height={10} width={50} borderRadius={14} />
          </FlexContainer>
          <div style={{ marginTop: '2.2rem' }}>
            <Skeleton height={10} width="25%" borderRadius={14} />
          </div>
        </>
      ) : (
        <>
          <ReactECharts option={options} style={style} />
          <p>{subtitle}</p>
        </>
      )}
    </>
  );
};
